export default __webpack_public_path__ + "static/media/purple-book.30bd4f08.png";